import Header from "./Header";
import Footer from "./Footer";
import WatiWidget from "./WatiWidget";
import IraChat from "./IraChat";
import { CookieConsent } from "./CookieConsent";
import { NewsletterPopup } from "./NewsletterPopup";
import StickyEnquireNudge from "./StickyEnquireNudge";
import MobileActionBar from "./MobileActionBar";

export default function SiteLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Header />
            <main className="flex-1 pt-20">{children}</main>
            <Footer />
            <WatiWidget />
            <IraChat />
            <CookieConsent />
            <NewsletterPopup />
            <StickyEnquireNudge />
            <MobileActionBar />
        </div>
    );
}
